import { Array } from 'stdlib/Array'

import type { TOs } from '../definitions'
import { LINUX_OSS } from '../definitions'

/**
 * Az OS Linux?
 * @param os - Os típusa.
 */
export default function isLinux (os: TOs): boolean {
  return Array.includes(LINUX_OSS, os)
}
